import { http } from "api/apiConfig";
import { ADDRESS_HISTORY, CUSTOMER_ADDRESS_HISTORY } from "constants/endpoints";
export const fetchAddressHistoryByWorkOrderId = async (workOrderId) => {
    const url = ADDRESS_HISTORY(workOrderId);
    const { data } = await http.get(url);
    return data;
};
export const fetchAddressHistoryByValidAddressId = async (validAddressId) => {
    const url = CUSTOMER_ADDRESS_HISTORY(validAddressId);
    const { data } = await http.get(url);
    return data;
};
